import {ProxyCounter} from '@yandex-data-ui/cloud-components';

import {UserCounter} from './metrika';

enum Counters {
    Main = 'main',
    Form = 'form',
    Group = 'group',
}

const {metrikaId, surveyMetrika, groupMetrika} = window.YC;

export const metrika = new ProxyCounter(Counters.Main);

export const userCounters: UserCounter[] = [];

function initCounter(name: Counters, id: number) {
    ProxyCounter.createCounters([
        {
            name,
            id,
        },
    ]);
}

export function initMetrika() {
    if (metrikaId) {
        initCounter(Counters.Main, metrikaId);
    }
    initUserCounters();
}

export function initUserCounters() {
    if (surveyMetrika) {
        initCounter(Counters.Form, Number(surveyMetrika));
        userCounters.push(new ProxyCounter(Counters.Form));
    }
    if (groupMetrika) {
        initCounter(Counters.Group, Number(groupMetrika));
        userCounters.push(new ProxyCounter(Counters.Group));
    }
}
